// 定义WebBridge类
class WebBridge {
    constructor() {
        this.eventMap = new Map(); window.chrome?.webview?.addEventListener("message", (e) => {
            const msg = e.data;
            if (!msg || !msg.eventName) return;

            const fn = this.eventMap.get(msg.eventName);
            if (fn) fn(msg.data);
        });
    }

    on(eventName, callback) {
        this.eventMap.set(eventName, callback);
    }

    send(eventName, data) {
        window.chrome?.webview?.postMessage({
            eventName,
            data,
        });
    }
}

export const webBridge = new WebBridge();